import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery, IconButton } from '@mui/material';
import FeaturedProductCard from './FeaturedProductCard';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';

const FeaturedProductsSlideshow = ({ products }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Minimum swipe distance (in px) to trigger slide change
  const minSwipeDistance = 50;

  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(timer);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % products.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + products.length) % products.length);
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }
  };

  if (!Array.isArray(products) || products.length === 0) {
    return null;
  }

  return (
    <Box
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      sx={{
        position: 'relative',
        width: '100%',
        height: { xs: 'auto', md: '300px' },
        overflow: 'hidden',
        mb: { xs: 0, md: 2 },
        touchAction: 'pan-y pinch-zoom'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          transition: 'transform 0.5s ease',
          transform: `translateX(-${currentIndex * 100}%)`,
          height: '100%',
        }}
      >
        {products.map((product) => (
          <Box
            key={product._id}
            sx={{
              minWidth: '100%',
            }}
          >
            <FeaturedProductCard product={product} />
          </Box>
        ))}
      </Box>

      {!isMobile && (
        <IconButton
          onClick={prevSlide}
          sx={{
            position: 'absolute',
            left: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            opacity: 0.2,  // More transparent
            backgroundColor: 'rgba(255, 255, 255, 0.9)',  // Semi-transparent background
            '&:hover': {
              opacity: 0.8,
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
            },
          }}
        >
          <ArrowLeft sx={{
               fontSize: '3rem',
          }}/>
        </IconButton>
      )}

      {!isMobile && (
        <IconButton
          onClick={nextSlide}
          sx={{
            position: 'absolute',
            right: 16,
            top: '50%',
            transform: 'translateY(-50%)',
            opacity: 0.2,  // More transparent
            backgroundColor: 'rgba(255, 255, 255, 0.9)',  // Semi-transparent background
            '&:hover': {
              opacity: 0.8,
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
            },
          }}
        >
          <ArrowRight sx={{
               fontSize: '3rem',
          }}/>
        </IconButton>
      )}
    </Box>
  );
};

export default FeaturedProductsSlideshow;